/**
 * Telemetry event catalog for Danny Tasks.
 *
 * All event names use snake_case and are grouped by category.
 * Each event has an origin indicating which app emits it.
 */
export const EventCategory = {
    PRODUCT: 'product',
    AI: 'ai',
    NAVIGATION: 'navigation',
    CONVERSION: 'conversion',
    DISCOVERY: 'discovery',
    ONBOARDING: 'onboarding',
};
export const Events = {
    // Product (api)
    TASK_CREATED: 'task_created',
    TASK_COMPLETED: 'task_completed',
    TASK_DELETED: 'task_deleted',
    PROJECT_CREATED: 'project_created',
    VIEW_CREATED: 'view_created',
    LABEL_APPLIED: 'label_applied',
    // AI (api)
    CHAT_MESSAGE_SENT: 'chat_message_sent',
    TRANSCRIPTION_STARTED: 'transcription_started',
    AI_CLASSIFICATION_TRIGGERED: 'ai_classification_triggered',
    AI_ESTIMATION_TRIGGERED: 'ai_estimation_triggered',
    // Navigation (web / any)
    PAGE_VIEWED: 'page_viewed',
    APP_OPENED: 'app_opened',
    SIDE_PANEL_OPENED: 'side_panel_opened',
    // Conversion (api)
    SIGNUP_COMPLETED: 'signup_completed',
    SUBSCRIPTION_UPGRADED: 'subscription_upgraded',
    // Discovery (api)
    FIRST_TASK_CREATED: 'first_task_created',
    FIRST_CHAT_USED: 'first_chat_used',
    FIRST_TRANSCRIPTION_USED: 'first_transcription_used',
    FIRST_VIEW_USED: 'first_view_used',
    // Onboarding (api) — welcome-email funnel per spec §14
    WELCOME_EMAIL_SENT: 'welcome_email_sent',
    WELCOME_EMAIL_REPLIED: 'welcome_email_replied',
    WELCOME_EMAIL_FALLBACK_USED: 'welcome_email_fallback_used',
};
export const EventOrigin = {
    // Product
    [Events.TASK_CREATED]: 'api',
    [Events.TASK_COMPLETED]: 'api',
    [Events.TASK_DELETED]: 'api',
    [Events.PROJECT_CREATED]: 'api',
    [Events.VIEW_CREATED]: 'api',
    [Events.LABEL_APPLIED]: 'api',
    // AI
    [Events.CHAT_MESSAGE_SENT]: 'api',
    [Events.TRANSCRIPTION_STARTED]: 'api',
    [Events.AI_CLASSIFICATION_TRIGGERED]: 'api',
    [Events.AI_ESTIMATION_TRIGGERED]: 'api',
    // Navigation
    [Events.PAGE_VIEWED]: 'web',
    [Events.APP_OPENED]: 'web',
    [Events.SIDE_PANEL_OPENED]: 'any',
    // Conversion
    [Events.SIGNUP_COMPLETED]: 'api',
    [Events.SUBSCRIPTION_UPGRADED]: 'api',
    // Discovery
    [Events.FIRST_TASK_CREATED]: 'api',
    [Events.FIRST_CHAT_USED]: 'api',
    [Events.FIRST_TRANSCRIPTION_USED]: 'api',
    [Events.FIRST_VIEW_USED]: 'api',
    // Onboarding
    [Events.WELCOME_EMAIL_SENT]: 'api',
    [Events.WELCOME_EMAIL_REPLIED]: 'api',
    [Events.WELCOME_EMAIL_FALLBACK_USED]: 'api',
};
//# sourceMappingURL=events.js.map